<template>
  <b-modal
    :id="modalId"
    :title="modalTitle"
    size="lg"
    role="dialog"
    modal-class="regular"
    centered
    no-close-on-backdrop
    :ok-title="okTitle"
    :ok-only="okOnly"
    :ok-disabled="okDisabled"
    @shown="onModalShown"
  >
    <template slot="default">
      <div class="custom-modal-content">
        <div>
          <b-row>
            <b-col>
              <b-container class="label">Width:</b-container>
              <b-form-input
                v-model="$v.embedParams.width.$model"
                placeholder="Enter the width (optional)"
                class="modal-input"
                v-bind:class="{ 'is-invalid': $v.embedParams.width.$error }"
                @input="updateEmbedCode"
              ></b-form-input>
            </b-col>
            <b-col>
              <b-container class="label">Height:</b-container>
              <b-form-input
                v-model="$v.embedParams.height.$model"
                placeholder="Enter the height (optional)"
                class="modal-input"
                v-bind:class="{ 'is-invalid': $v.embedParams.height.$error }"
                @input="updateEmbedCode"
              ></b-form-input>
            </b-col>
          </b-row>
          <hr />
          <b-row>
            <b-col>
              <b-container class="label">Embed Code:</b-container>
              <b-form-textarea
                v-model="generatedEmbedCode"
                rows="11"
                class="modal-input"
                readonly
                style="font-family: monospace;"
              ></b-form-textarea>
            </b-col>
          </b-row>
          <hr />
          <b-row>
            <b-col>
              <b-container>
                <p>
                  <strong>Hint</strong>: When embedding an iframe on your website, rather than specifying
                  the dimensions explicitly, you might want to make use of the responsive design.
                </p>
                <p>
                  Bootstrap specifically makes it very easy to implement. See the documentation for:
                </p>
                <ul style="margin-bottom: 0;">
                  <li><a target="_blank" href="https://getbootstrap.com/docs/5.1/helpers/ratio/">Ratios in Bootstrap 5.x</a></li>
                  <li><a target="_blank" href="https://getbootstrap.com/docs/4.6/utilities/embed/">Embeds in Bootstrap 4.x</a></li>
                  <li><a target="_blank" href="https://getbootstrap.com/docs/3.4/components/#responsive-embed">Embeds in Bootstrap 3.x</a></li>
                </ul>
              </b-container>
            </b-col>
          </b-row>
        </div>
      </div>
    </template>
  </b-modal>
</template>

<script>
import * as harpraApi from "@/services/api.service";

import { integer } from 'vuelidate/lib/validators'

export default {
  name: "WebAREmbedCodeModal",
  props: {
    modalId: String,
  },
  data() {
    return {
      okTitle: "Close",
      okDisabled: false,
      okOnly: true,
      embedId: null,
      embedTitle: null,
      embedParams: this.createDefaultEmbedParams(),
      generatedEmbedCode: "",
      DEFAULT_GENERATED_EMBED_CODE: "...",
    }
  },
  computed: {
     modalTitle() {
      return `Web AR Embed Code for '${this.embedTitle}'`;
    }
  },
  validations: {
    embedParams: {
      width: {
        integer,
      },
      height: {
        integer,
      },
    },
  },
  methods: {
    show(embedId, embedTitle) {
      this.embedId = embedId;
      this.embedTitle = embedTitle;
      this.$bvModal.show(this.modalId);
    },
    onModalShown() {
      this.resetForm();
      this.updateEmbedCode();
    },
    resetForm() {
      this.embedParams = this.createDefaultEmbedParams();
      this.generatedEmbedCode = this.DEFAULT_GENERATED_EMBED_CODE;
      this.$v.$reset();
    },
    createDefaultEmbedParams() {
      return {
        width: "",
        height: "",
      };
    },
    async updateEmbedCode() {
      this.generatedEmbedCode = this.DEFAULT_GENERATED_EMBED_CODE;

      if (this.$v.$anyError) {
        return;
      }

      const result =
        await harpraApi.getWebAREmbedCode(
          this.embedId,
          this.embedParams.width,
          this.embedParams.height);

      this.generatedEmbedCode = result;
    },
  },
  created() {
  },
  mounted() {
  },
}
</script>
